/**
 * Loại thuế thu nhập
 */
export default {
  Regular: 0, // thường xuyên

  NoneRegular: 1, // bất thường
};
